// extracted by mini-css-extract-plugin
module.exports = {"ErrorsModal":"ErrorsModal_ErrorsModal__1Alpm"};